import { render } from "./InvoiceTable.vue?vue&type=template&id=6fe7f3b4&scoped=true&ts=true&lang=pug"
import script from "./InvoiceTable.vue?vue&type=script&lang=ts"
export * from "./InvoiceTable.vue?vue&type=script&lang=ts"

import "./InvoiceTable.vue?vue&type=style&index=0&id=6fe7f3b4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe7f3b4"]])

export default __exports__